export default __webpack_public_path__ + "static/germaine1-d98c78b13268e82492675ea979be02e5.jpg";